var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_6995)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.08271 2.57741C3.84975 3.36694 2.25 5.49665 2.25 8C2.25 9.54528 2.85858 10.9469 3.85071 11.9807C4.00067 12.137 4.15936 12.2848 4.32598 12.4234C4.64446 12.6882 4.68793 13.1611 4.42307 13.4796C4.15822 13.798 3.68534 13.8415 3.36687 13.5766C3.15704 13.4021 2.95724 13.216 2.76844 13.0193C1.51903 11.7174 0.75 9.9477 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75C8.30335 0.75 8.57682 0.932732 8.69291 1.21299C8.809 1.49324 8.74483 1.81583 8.53033 2.03033C7.53821 3.02245 6.75 3.82976 6.75 5.5C6.75 7.57267 8.41581 9.25 10.5 9.25C11.9191 9.25 13.1564 8.63763 13.9216 7.72295C14.1268 7.47771 14.4649 7.38952 14.7637 7.50328C15.0625 7.61704 15.2564 7.90775 15.2465 8.22734C15.1262 12.1265 11.928 15.25 8 15.25C7.62148 15.25 7.24925 15.2209 6.88555 15.1648C6.47619 15.1016 6.19557 14.7185 6.25878 14.3091C6.32199 13.8997 6.70509 13.6191 7.11445 13.6823C7.40269 13.7268 7.69839 13.75 8 13.75C10.454 13.75 12.5491 12.2126 13.3744 10.0485C12.525 10.4965 11.5418 10.75 10.5 10.75C7.58419 10.75 5.25 8.39789 5.25 5.5C5.25 4.24579 5.6012 3.32111 6.08271 2.57741Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_6995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.56d2ca3a.svg";
export { ForwardRef as ReactComponent };